import { render, staticRenderFns } from "./afterSalesScan.vue?vue&type=template&id=1902afcb&scoped=true"
import script from "./afterSalesScan.vue?vue&type=script&lang=js"
export * from "./afterSalesScan.vue?vue&type=script&lang=js"
import style0 from "./afterSalesScan.vue?vue&type=style&index=0&id=1902afcb&prod&scoped=true&lang=css"
import style1 from "./afterSalesScan.vue?vue&type=style&index=1&id=1902afcb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1902afcb",
  null
  
)

export default component.exports